import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withStockEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
